<script setup>
import { formattedDate, getAgeFromRange, swalError } from '@/helper';
import { get_assessment } from '@/services/assessment';
import { ref, onMounted } from 'vue';

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  child: {
    type: Object,
    required: true
  }
})

const isAssessment = ref(false)
function get_title(item){
  let title = ''
  if (item?.type == 'assessment_progress'){
    isAssessment.value = true
    if (item.attributes.is_completed){
      title = 'Completed Assessment'
    }else{
      title = 'Ongoing Assessment'
    }
  }else{
    if (item?.attributes.is_completed){
      title = 'Completed Intervention'
    }else{
      title = 'Ongoing Intervention'
    }
  }
  return title
}
function isShowIcon(item){
  let isShow = false
  if (item?.type == 'assessment_progress'){
    if (item.attributes.is_completed){
      isShow = true
    }
  }else{
    if (item?.attributes.is_completed){
      isShow = true
    }
  }
  return isShow
}

function get_age_done(){
  let age_done = getAgeFromRange(props.child?.attributes.date_of_birth, props.item?.attributes.updated_at)
  return age_done
}

const showInfo = ref(false)
const infoLoading = ref(true)
const assessmentInfo = ref({})
async function get_info(){
  showInfo.value = true
  let response = await get_assessment(props.item.attributes.assessment_id)
  infoLoading.value = false
  if (response.error){
    swalError(response.result.error, true)
    return
  }
  const { assessment } = response.result
  assessmentInfo.value = {
    code: assessment.data.attributes.code,
    name: assessment.data.attributes.name
  }
}
</script>

<template>
  <div class="card no-shadow border p-0 my-2">
    <div class="card-body py-2 row">
      <div class="col-md-9 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div v-auto-animate>
            <p class="report-date-top text-secondary mb-0">
              {{ formattedDate(item?.attributes.updated_at)}}
            </p>
            <p class="m-0 p-0 fw-medium tracking-wide"
              :class="isAssessment ? 'text-success': 'text-warning'"
            >
              <vue-feather v-if="isShowIcon(item)" type="star" 
              class="text-warning"
              size="1.25rem"
              ></vue-feather>
              {{ get_title(item) }}
            </p>
            <p class="secondary-text">
              Done at : {{ get_age_done() }} years old
            </p>
            <div v-if="showInfo">
              <template v-if="infoLoading">
                <loadingCard loadingType="list"/>
              </template>
              <template v-else>
                <p class="mb-0">
                  <span class="text-secondary">Code :</span> 
                  {{ assessmentInfo.code }}
                </p>
                <p>
                  <span class="text-secondary">Description :</span> 
                  {{ assessmentInfo.name }}
                </p>
              </template>
            </div>
          </div>
        </div>
        <div>
          <button class="btn icon-btn btn-light-warning" 
            @click="get_info"
            v-if="!showInfo && isAssessment"
          >
            <vue-feather type="more-horizontal"></vue-feather>
          </button>
          <button class="btn icon-btn btn-light-danger" 
            @click="showInfo = !showInfo"
            v-if="showInfo"
          >
            <vue-feather type="x"></vue-feather>
          </button>
        </div>
      </div>  
      <div class="report-date-side col-md-3 d-flex align-items-center">
        <p>{{ formattedDate(item?.attributes.updated_at)}}</p>
      </div>
    </div>
  </div>
</template>